import { Controller } from 'stimulus'
import autoComplete from '@tarekraafat/autocomplete.js'
import { fetch } from 'shared/js/fetch'
import { getUrlParams, setParamToUrl, removeValueOfParamToUrl } from 'shared/js/common';
import $ from 'jquery'

export default class extends Controller {
  static targets = [ 'field', 'query', 'form', 'autocomplete', 'results', 'pagination']

  connect() {
    this.hijackPagination()
    this.autoComplete = this.initializeAutocomplete()
  }

  initializeAutocomplete() {
    return new autoComplete(
      {
        data: {
          src: () => this.autocomplete(),
          key: ['text'],
          cache: false,
      },
      resultsList: {
        render: true,
        destination: this.autocompleteTarget,
        position: 'beforeend',
        container: (list) => {
          list.classList.add('border', 'border-t-0', 'bg-white', 'rounded-b', 'shadow-md')
          list.addEventListener('mouseenter', () => this.inAutocomplete = true)
          list.addEventListener('mouseleave', () => this.inAutocomplete = false)
        }
      },
      resultItem: {
        content: (result, resultElement) => {
          resultElement.classList.add('block', 'cursor-pointer', 'px-3', 'py-2', 'hover:bg-gray-200')
          resultElement.addEventListener('click', () => this.resultSelected(result.value))
          resultElement.innerHTML = result.match
        }
      },
      selector: () => this.queryTarget,
      threshold: 2,
      debounce: 300,
      searchEngine: (query, resultText) => {
        // handle product ID searches where result text doesn't match the query
        return this.autoComplete.search(query, resultText) || resultText
      },
      highlight: true,
      onSelection: ({ selection }) => this.resultSelected(selection.value),
    })
  }

  async autocomplete() {
    const response = await fetch(this.autocompleteUrl, {
      query: {
        field: this.fieldTarget.value,
        query: this.queryTarget.value,
      }
    })

    const data = await response.json()

    return data['items']
  }

  resultSelected({ text, link }) {
    this.queryTarget.value = text
    this.hideAutocomplete()

    if (link) {
      window.location.href = link
    } else {
      this.search({ page: 1 })
    }
  }

  onFilterChange(event) {
    const url = new URL(window.location.href);
    if (url.pathname.endsWith('/') && url.pathname.length > 1) {
      url.pathname = url.pathname.slice(0, -1);
    }
    const currentValue = event.target.parentElement.dataset.prName;
    if(event.target.parentElement.id === 'search-city') {
      if(event.target.checked) {
        setParamToUrl(url, 'city', currentValue);
      } else {
        removeValueOfParamToUrl(url, 'city', currentValue);
      }
    } else if (event.target.parentElement.id === 'search-country') {
      if(event.target.checked) {
        setParamToUrl(url, 'country', currentValue);
      } else {
        removeValueOfParamToUrl(url, 'country', currentValue);
      }
    } else if (event.target.parentElement.id === 'search-state') {
      if(event.target.checked) {
        setParamToUrl(url, 'state', currentValue);
      } else {
        removeValueOfParamToUrl(url, 'state', currentValue);
      }
    } else if (event.target.parentElement.id === 'search-category') {
      if(event.target.checked) {
        setParamToUrl(url, 'category', currentValue);
      } else {
        removeValueOfParamToUrl(url, 'category', currentValue);
      }
    }
    window.history.replaceState(null, null, url);
    const city = getUrlParams('city')
    const state = getUrlParams('state');
    const category = getUrlParams('category');
    this.search({ page: 1, category, city, state })
  }

  async search({ page, category = null, city = null, state = null }) {
    this.resultsTarget.classList.add('opacity-50')

    const formData = new FormData(this.formTarget),
    AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
    formData.append('authenticity_token', AUTH_TOKEN)
    if (page) formData.append('page', page)
    if (category) formData.append('category', category)
    if (city) formData.append('city', city)
    if (state) formData.append('state', state)
    
    const response = await fetch(this.formTarget.action, { method: 'POST', body: formData })
    const results  = await response.text()
    this.resultsTarget.innerHTML = results
    
    if($("#loading_complete")[0] != undefined){
      $("#loading_complete")[0].attributes["loading-complete"].value = false;
    }
    
    $('.operator-chart').easyPieChart({
      scaleColor: false,
      lineCap: 'round',
      lineWidth: 6,
      size: 40,
      animate: 1000,
      onStart: $.noop,
      onStop: $.noop,
    });
    $('[data-toggle="tooltip"]').tooltip()
    this.hijackPagination()
    
    this.resultsTarget.classList.remove('opacity-50')

    const elem = $(".loadmore_observer")[0]
    if (elem) {
      let options = {
        rootMargin: "120px",
        threshold: 1.0
      }
    
      function loadMoreProduct(entries){
        let statusLoading = $("#loading_complete")
        if(statusLoading[0] != undefined){
          if(statusLoading[0].attributes["execute"].value == 'false'){
            statusLoading[0].attributes["execute"].value = true;
          }else if(statusLoading[0].attributes["loading-process"].value == 'false' && statusLoading[0].attributes["loading-complete"].value == 'false'){
            statusLoading[0].attributes["loading-process"].value = true;
            $("#btn-loadmore-small-detail-product")[0].click();
          }
        }
      }
  
      const observer = new IntersectionObserver(loadMoreProduct, options)
      observer.observe(elem)
    }
  }

  // allows paginating through search results with POST requests
  hijackPagination() {
    this.paginationTarget.querySelectorAll('.page-link').forEach(element => {
      element.addEventListener('click', (event) => {
        event.preventDefault()

        const match = element.href.match(/page=(\d+)/)
        const page  = match ? match[1] : 1
        const category = new URLSearchParams(window.location.search).get('category');
        const city = getUrlParams('city');
        const country = getUrlParams('country');

        this.search({ page, category, city, country })
      })
    })
  }

  onChange() {
    const category = new URLSearchParams(window.location.search).get('category');
    const city = getUrlParams('city');
    const country = getUrlParams('country');
    this.search({ page: 1, category, city, country })
  }

  onBlur() {
    // delay hiding dropdown when clicking on autocomplete results

    if (!this.inAutocomplete) this.hideAutocomplete()
  }

  onFocus() {
    this.showAutocomplete()
  }

  hideAutocomplete() {
    this.autocompleteTarget.classList.add('hidden')
  }

  showAutocomplete() {
    this.autocompleteTarget.classList.remove('hidden')
  }

  get autocompleteUrl() {
    return this.data.get('autocomplete-url')
  }
}
